import styled from "styled-components";
import { FlexColumn } from "./common.styles";
import { ErrorMessage } from "./FormHelper.styles";
import { HXPasswordTextField as SharedHXPasswordTextField } from "./HXPasswordTextField";
export const HXPasswordTextField = styled(SharedHXPasswordTextField) `
    width: 360px;
`;
export const PasswordFlexColumn = styled(FlexColumn) `
    & ${ErrorMessage} {
        width: 700px;
        margin: 0;
    }
`;
